import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Tooltip", "data", "renderLeft", "height", "width", "mapWidth", "mapHeight"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import { createElement, useRef, useState, useLayoutEffect } from 'react';
import { getTootlipPosition } from '@gisatcz/ptr-core';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var MARGIN = 10;
var WIDTH_FALLBACK = 0;
var DeckTooltip = function DeckTooltip(_ref) {
  var Tooltip = _ref.Tooltip,
    data = _ref.data,
    renderLeft = _ref.renderLeft,
    height = _ref.height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'auto' : _ref$width,
    mapWidth = _ref.mapWidth,
    mapHeight = _ref.mapHeight,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var tooltipElement = useRef();
  var tooltipElementData = tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.current;
  var _ref2 = data.event || {},
    x = _ref2.x,
    y = _ref2.y;
  var heightRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipHeight = _useState2[0],
    setTooltipHeight = _useState2[1];
  useLayoutEffect(function () {
    var _tooltipElement$curre, _tooltipElement$curre2;
    heightRef.current = tooltipElement === null || tooltipElement === void 0 ? void 0 : (_tooltipElement$curre = tooltipElement.current) === null || _tooltipElement$curre === void 0 ? void 0 : _tooltipElement$curre.offsetHeight;
    if ((tooltipElement === null || tooltipElement === void 0 ? void 0 : (_tooltipElement$curre2 = tooltipElement.current) === null || _tooltipElement$curre2 === void 0 ? void 0 : _tooltipElement$curre2.offsetHeight) !== tooltipHeight) {
      var _tooltipElement$curre3;
      setTooltipHeight(tooltipElement === null || tooltipElement === void 0 ? void 0 : (_tooltipElement$curre3 = tooltipElement.current) === null || _tooltipElement$curre3 === void 0 ? void 0 : _tooltipElement$curre3.offsetHeight);
    }
  }, [data]);

  // Get width from element if not passed as a prop
  if (tooltipElementData && !width) {
    width = (tooltipElementData === null || tooltipElementData === void 0 ? void 0 : tooltipElementData.clientWidth) || WIDTH_FALLBACK;
  }
  var contentWidth = (tooltipElementData === null || tooltipElementData === void 0 ? void 0 : tooltipElementData.clientWidth) || width;
  // Get height from element if not passed as a prop
  if (tooltipElementData && !height) {
    height = tooltipElementData === null || tooltipElementData === void 0 ? void 0 : tooltipElementData.clientHeight;
  }

  // TODO move map tooltip on the other side of the cursor when coursor approach open right panel
  var getTooltipStyle = function getTooltipStyle() {
    return getTootlipPosition('corner', renderLeft ? ['left', 'right', 'top', 'bottom'] : ['right', 'left', 'top', 'bottom'], [0, mapWidth, mapHeight, 0], MARGIN);
  };
  var _getTooltipStyle = getTooltipStyle()(x, y, contentWidth, height),
    top = _getTooltipStyle.top,
    left = _getTooltipStyle.left;
  var style = tooltipElement && tooltipElement.offsetWidth !== 0 && tooltipElement.offsetHeight !== 0 ? _objectSpread({}, {
    left: left,
    top: top,
    width: width
  }) : _objectSpread(_objectSpread({}, {
    left: left,
    top: top,
    width: width
  }), {}, {
    position: 'absolute',
    overfloat: 'auto'
  });
  if (tooltipElement && !tooltipElement.current) {
    style.display = 'none';
  }
  return /*#__PURE__*/_jsx("div", {
    className: "ptr-DeckTooltip",
    style: style,
    ref: tooltipElement,
    children: /*#__PURE__*/createElement(Tooltip, _objectSpread(_objectSpread({}, data), restProps))
  });
};
DeckTooltip.propTypes = {
  data: PropTypes.object,
  mapWidth: PropTypes.number,
  mapHeight: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
  renderLeft: PropTypes.bool,
  renderTop: PropTypes.bool,
  Tooltip: PropTypes.func
};
export default DeckTooltip;